import { isRejectedWithValue } from "@reduxjs/toolkit";
import { onSignOutSuccess } from "./auth/sessionSlice";
import { userLoggedOut } from "./auth/userSlice";
import { reset } from "./studio/slice";
import { reset as propertyReset } from "./studio/propertiesSlice";

const unauthorizedCode = [401, 400, 500];
export const authorizationMiddleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    
    if (
      unauthorizedCode.includes(action.payload.status) &&
      ["Unauthorized", "Token is blacklisted"].includes(
        action.payload?.data?.detail
      )
    ) {
      api.dispatch(onSignOutSuccess());
      // api.dispatch(userLoggedOut());
      // api.dispatch(reset());
      // api.dispatch(propertyReset());
    }
    if (
      [401].includes(action.payload.status) &&
      ["user_inactive"].includes(
        action.payload?.data?.code
      )
    ) {
      api.dispatch(onSignOutSuccess());
      api.dispatch(userLoggedOut());
      api.dispatch(reset());
      api.dispatch(propertyReset());
    }
  }
  return next(action);
};
